export enum BlockMutationAction {
  create = 'create',
  update = 'update',
  delete = 'delete',
  move = 'move',
  duplicate = 'duplicate'
}
